import API from '../api'
import postUrl from './paths'

// Records an invoice payment. Sends a multipart form: `data` = JSON payload,
// `files` = one entry per uploaded document (images / docs).
export const createInvoicePayment = (payload, files = []) =>
	new Promise((resolve, reject) => {
		const formData = new FormData()
		formData.append('data', JSON.stringify(payload))
		;(files ?? []).forEach((file) => formData.append('files', file))

		API.post(postUrl.createInvoicePayment, formData, {})
			.then((response) => resolve(response.data))
			.catch((err) => reject(err))
	})
